export const BaseRole = {
  Admin: "Admin",
  Product: "Product",
};

// Common access configurations
const VIEW_ONLY_ACCESS = {
  operations: {
    view: true,
  },
};

const BUILDS_ACCESS = {
  operations: {
    view: true,
    viewdetails: true,
    add: true,
  },
};

export const ADMIN_ROLE_ACCESS = {
  user: {
    operations: {
      view: true,
      viewdetails: true,
      add: true,
      update: true,
      delete: true,
      changePassword:true
    },
  },
  feature: {
    operations: {
      view: true,
      viewdetails: true,
      add: true,
      update: true,
      delete: true,
    },
  },
  executionengine: {
    operations: {
      view: true,
      viewdetails: true,
      add: true,
      update: true,
      delete: true,
    },
  },
  coreengine: {
    operations: {
      view: true,
      viewdetails: true,
      add: true,
      update: true,
      delete: true,
    },
  },
  coreengine_feature: {
    operations: {
      view: true,
      viewdetails: true,
      add: true,
      update: true,
      delete: true,
    },
  },
  products: {
    operations: {
      view: true,
      viewdetails: true,
      add: true,
      update: true,
      delete: true,
      enabled: true,
    },
  },
  products_apps: {
    operations: {
      view: true,
      viewdetails: true,
      add: true,
      update: true,
      delete: true,
      enabled: true,
    },
  },
  products_user: {
    operations: {
      view: true,
      viewdetails: true,
      add: true,
      update: true,
      delete: true,
    },
  },
  products_apps_testengine: {
    operations: {
      view: true,
      viewdetails: true,
      add: true,
      update: true,
      delete: true,
    },
  },
  builds: BUILDS_ACCESS,
  dashboard: VIEW_ONLY_ACCESS,
  "external-dashboard": VIEW_ONLY_ACCESS,
  document: VIEW_ONLY_ACCESS,
};

export const PRODUCT_ROLE_ACCESS = {
  user: {
    operations: {
      view: false,
      viewdetails: false,
      add: false,
      update: true,
      delete: false,
      changePassword:true
    },
  },
  feature: {
    operations: {
      view: false,
      viewdetails: false,
      add: false,
      update: false,
      delete: false,
    },
  },
  executionengine: {
    operations: {
      view: false,
      viewdetails: false,
      add: false,
      update: false,
      delete: false,
    },
  },
  coreengine: {
    operations: {
      view: false,
      viewdetails: false,
      add: false,
      update: false,
      delete: false,
    },
  },
  coreengine_feature: {
    operations: {
      view: false,
      viewdetails: false,
      add: false,
      update: false,
      delete: false,
    },
  },
  products: {
    operations: {
      view: true,
      viewdetails: true,
      add: false,
      update: false,
      delete: false,
      enabled: false,
    },
  },
  products_apps: {
    operations: {
      view: true,
      viewdetails: true,
      add: false,
      update: false,
      delete: false,
      enabled: false,
    },
  },
  products_user: {
    operations: {
      view: true,
      viewdetails: true,
      add: false,
      update: false,
      delete: false,
    },
  },
  products_apps_testengine: {
    operations: {
      view: true,
      viewdetails: true,
      add: false,
      update: false,
      delete: false,
    },
  },
  builds: BUILDS_ACCESS,
  dashboard: VIEW_ONLY_ACCESS,
  "external-dashboard": VIEW_ONLY_ACCESS,
  document: VIEW_ONLY_ACCESS,
};

// export const Role = {
//     user:{
//         operations : {
//             view : [BaseRole.Admin],
//             viewdetails : [BaseRole.Admin],
//             add : [BaseRole.Admin],
//             update : [BaseRole.Admin],
//             delete: [BaseRole.Admin]
//         }
//     },
//     feature:{
//         operations : {
//             view : [BaseRole.Admin],
//             viewdetails : [BaseRole.Admin],
//             add : [BaseRole.Admin],
//             update : [BaseRole.Admin],
//             delete: [BaseRole.Admin]
//         }
//     },
//     coreengine:{
//         operations : {
//             view : [BaseRole.Admin],
//             viewdetails : [BaseRole.Admin],
//             add : [BaseRole.Admin],
//             update : [BaseRole.Admin],
//             delete: [BaseRole.Admin]
//         }
//     },
//     products:{
//         operations : {
//             view : [BaseRole.Admin, BaseRole.Product],
//             viewdetails : [BaseRole.Admin, BaseRole.Product],
//             add : [BaseRole.Admin],
//             update : [BaseRole.Admin],
//             delete: [BaseRole.Admin]
//         }
//     },
//     products_apps:{
//         operations : {
//             view : [BaseRole.Admin, BaseRole.Product],
//             viewdetails : [BaseRole.Admin, BaseRole.Product],
//             add : [BaseRole.Admin],
//             update : [BaseRole.Admin],
//             delete: [BaseRole.Admin]
//         }
//     },
//     products_apps_testengine:{
//         operations : {
//             view : [BaseRole.Admin, BaseRole.Product],
//             viewdetails : [BaseRole.Admin, BaseRole.Product],
//             add : [BaseRole.Admin],
//             update : [BaseRole.Admin],
//             delete: [BaseRole.Admin]
//         }
//     },
//     builds:{
//         operations : {
//             view : [BaseRole.Admin, BaseRole.Product],
//             viewdetails : [BaseRole.Admin, BaseRole.Product],
//             add : [BaseRole.Admin, BaseRole.Product],
//         }
//     },
//     dashboard:{
//         operations : {
//             view : [BaseRole.Admin, BaseRole.Product],
//             // viewdetails : [BaseRole.Admin, BaseRole.Product],
//             // add : [BaseRole.Admin],
//             // update : [BaseRole.Admin],
//             // delete: [BaseRole.Admin]
//         }
//     },
//     document:{
//         operations : {
//             view : [BaseRole.Admin, BaseRole.Product],
//             // viewdetails : [BaseRole.Admin, BaseRole.Product],
//             // add : [BaseRole.Admin],
//             // update : [BaseRole.Admin],
//             // delete: [BaseRole.Admin]
//         }
//     },
// }
